USER_UPDATE_SCHEMA